<template>
  <v-container fluid>
    <Header title="Moje objednávky" subtitle="Prehľad objednávok" />
    <v-layout row wrap align-center justify-center v-if="orders" pt-3>
      <v-flex xs12 md10 lg8>
        <v-data-table
          :headers="headers"
          :items="orders"
          item-key="id"
          class="elevation-1"
          disable-initial-sort
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.orderId }}</td>
              <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="text-xs-right">
                <v-icon color="success" v-if="props.item.isConfirmed">done</v-icon>
                <v-icon color="warning" v-else>block</v-icon>
              </td>
              <td class="text-xs-right">
                <span v-if="props.item.orderStatus == 0">Nová</span>
                <span v-if="props.item.orderStatus == 1">Spracováva sa</span>
                <span v-if="props.item.orderStatus == 2">Hotová</span>
                <span v-if="props.item.orderStatus == 3">Ukončená</span>
                <span v-if="props.item.orderStatus == 4">Zrušená</span>
              </td>
              <td
                class="text-xs-right"
              >{{ props.item.created | moment("dddd, Do MMMM YYYY, HH:mm:ss") }}</td>
              <td class="text-xs-right">
                <v-icon @click="expandClick(props.item)">assignment</v-icon>
                <!-- <v-icon @click="getDoc(props.item)">face</v-icon> -->
                <v-icon
                  v-if="props.item.orderStatus == 0 && !props.item.isConfirmed"
                  color="warning"
                  @click="cancelOrder(props.item)"
                >cancel</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="order">
      <v-flex xs12>
        <v-dialog v-model="dialog" max-width="1200">
          <v-card>
            <v-toolbar color="primary">
              <v-toolbar-title class="white--text">Objednávka ID: {{order.orderId}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <span
                class="white--text"
              >{{ order.createdDate | moment("dddd, Do MMMM YYYY, HH:mm:ss") }}</span>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap pb-4>
                <!-- <v-flex xs4>
                  <span>Status objednávky: {{order.orderStatus}}</span>
                </v-flex>
                <v-flex xs4>
                  <span>Potvrdená: {{order.isConfirmed}}</span>
                </v-flex>-->
                <v-flex xs4>
                  <span>Cena objednávky: {{ order.orderDetails[0].price }} € bez DPH</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table
                    hide-headers
                    :items="order.orderDetails[0].storageCard.product.boards"
                    item-key="id"
                    light
                    :expand="expand"
                  >
                    <template v-slot:items="props">
                      <tr @click="props.expanded = !props.expanded">
                        <td class="text-xs-left">{{ props.item.name }}</td>
                        <td class="text-xs-left">Kód: {{ props.item.decor.productCode }}</td>
                        <td class="text-xs-left">{{ props.item.decor.name }}</td>
                        <td class="text-xs-left">
                          Dupla:
                          <span v-if="props.item.duplex">áno</span>
                          <span v-else>nie</span>
                        </td>
                        <td class="text-xs-right">{{ props.item.quantity }} ks</td>
                        <td class="text-xs-right">{{ props.item.width }} mm</td>
                        <td class="text-xs-right">{{ props.item.height }} mm</td>
                      </tr>
                    </template>
                    <template v-slot:expand="props">
                      <v-list dense v-if="canExpand(props.item)">
                        <v-list-tile v-if="props.item.edgeFrontDecor != null">
                          <v-list-tile-content>
                            <v-list-tile-title>Hrana vpredu: {{props.item.edgeFrontDecor.name}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.edgeBackDecor != null">
                          <v-list-tile-content>
                            <v-list-tile-title>Hrana vzadu: {{props.item.edgeBackDecor.name}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.edgeLeftDecor != null">
                          <v-list-tile-content>
                            <v-list-tile-title>Hrana vlavo: {{props.item.edgeLeftDecor.name}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.edgeRightDecor != null">
                          <v-list-tile-content>
                            <v-list-tile-title>Hrana vpravo: {{props.item.edgeRightDecor.name}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </template>
                  </v-data-table>
                  <!-- {{item}} -->
                </v-flex>
                <!-- {{orderDetail}} -->
              </v-layout>
              <!-- <OptimizationGallery
                :images="orderDetail.order.optimizations[0].optimizationResult.OptimizationResultItems"
                empty="Zadajte položky a vyskúšajte optimalizáciu"
              />-->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="priamary" flat @click="dialog = false">Zatvoriť</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
import OrderService from "@/services/OrderService";
// import OptimizationGallery from "@/views/cutting/components/OptimizationGallery";

import Controller from "@/mixins/controlsMixins";

export default {
  name: "PersonalOrders",
  components: {
    Header
    // OptimizationGallery
  },
  mixins: [Controller],
  data() {
    return {
      orders: null,
      order: null,
      dialog: false,
      expand: false,
      headers: [
        {
          text: "Číslo obj.",
          value: "orderId",
          align: "left"
        },
        {
          text: "Popis",
          value: "description",
          align: "left"
        },
        {
          text: "Potvrdenie obj.",
          value: "isConfirmed",
          align: "right"
        },
        {
          text: "Stav",
          value: "status",
          align: "right"
        },
        {
          text: "Prijatá",
          value: "createdDate",
          align: "right"
        },
        {
          text: "",
          value: "",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.loadAccount();
  },
  methods: {
    loadAccount() {
      this.openGlobalLoader("Načítava sa ...");
      new OrderService()
        .getPersonOrders()
        .then(response => {
          console.log(response.data);
          this.orders = response.data;
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    expandClick(order) {
      this.openGlobalLoader("Načítava sa ...");
      new OrderService()
        .getPersonOrderDetail(order.orderId)
        .then(response => {
          console.log(response.data);
          this.order = response.data;
          this.dialog = true;
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    getDoc(order) {
      this.openGlobalLoader("Načítava sa ...");
      new OrderService()
        .getOrderDocument(order.orderId)
        .then(response => {
          console.log(response);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    cancelOrder(order) {
      if (!confirm("Naozaj chcete zrušiť objednávku?")) {
        return;
      }

      this.openGlobalLoader("Ruší sa ...");
      new OrderService()
        .cancelOrder(order.orderId)
        .then(response => {
          console.log(response.data);
          this.loadAccount();
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    // submit() {
    //     this.$validator.validateAll().then(result => {
    //         if (result) {
    //             this.openGlobalLoader('Ukladá sa ...')
    //             new AccountService()
    //                 .putPersonIdentity(this.account)
    //                 .then(() => {
    //                     console.info('updated account');
    //                 })
    //                 .catch(e => {
    //                     console.error(e)
    //                 })
    //                 .finally(() => {
    //                     this.closeGlobalLoader()
    //                     this.loadAccount()
    //                 })
    //         }
    //     })
    // },
    canExpand(edges) {
      if (
        edges.edgeFrontDecor != null ||
        edges.edgeBackDecor != null ||
        edges.edgeLeftDecor != null ||
        edges.edgeRightDecor != null
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style>
</style>